import "regenerator-runtime/runtime";

import { hot } from "react-hot-loader/root";
import React from "react";
import PropTypes from "prop-types";

// import "@regenerator/"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";

/* import "./apple_music/slider.scss"; */
import "./AppleMusic.scss";

import ErrorBoundary from "./ErrorBoundary.js";
import PlayerTime from "./PlayerTime.js";
import TrackList from "./TrackList.js";

class AppleMusic extends React.Component {
  constructor(props) {
    super(props);

    this.developerToken = process.env.MUSIC_KIT_DEVELOPER_TOKEN;

    // console.log("MusicKit: debug dev token.");

    MusicKit.configure({
      developerToken: this.developerToken,
      app: {
        name: "The FADER",
        build: "1",
      },
    });

    this.music = MusicKit.getInstance();

    this.state = {
      mediaItem: null,
      isPlaying: false,
      isLoading: false,
      playbackTime: 0,
      isAuthorized: this.music.isAuthorized,
      nowPlayingItem: null,
      isOverlay: false,
      showUpsell: false,
      showLogout: false,
      upsellClosed: false,
    };

    if (this.props.song_id) {
      this.state.mediaType = "song";
      this.state.mediaId = this.props.song_id;
    } else if (this.props.playlist_id) {
      this.state.mediaType = "playlist";
      this.state.mediaId = this.props.playlist_id;
    } else if (this.props.album_id) {
      this.state.mediaType = "album";
      this.state.mediaId = this.props.album_id;
    }

    this.handlePlaybackTimeDidChange = this.handlePlaybackTimeDidChange.bind(
      this
    );

    this.handlePlaybackStateDidChange = this.handlePlaybackStateDidChange.bind(
      this
    );

    this.handleAuthorizationStatusDidChange = this.handleAuthorizationStatusDidChange.bind(
      this
    );

    this.handleMediaItemDidChange = this.handleMediaItemDidChange.bind(this);

    this.signIn = this.signIn.bind(this);
    this.signOut = this.signOut.bind(this);

    this.closeUpsellModal = this.closeUpsellModal.bind(this);
    this.closeLogoutModal = this.closeLogoutModal.bind(this);
    this.tryItNow = this.tryItNow.bind(this);
    this.showLogoutModal = this.showLogoutModal.bind(this);

    this.play = this.play.bind(this);

    // this.props.music = MusicKit.getInstance();

    /* console.log("auth: ", this.music.isAuthorized); */
  }

  componentDidMount() {
    console.log("AppleMusic componentDidMount");
    document.addEventListener("musickitloaded", function () {
      console.log("componentDidMount musickitloaded");
    });

    this.sendGaEvent("willLoad");

    this.setup();

    this.music.addEventListener(
      MusicKit.Events.playbackTimeDidChange,
      this.handlePlaybackTimeDidChange
    );

    this.music.addEventListener(
      MusicKit.Events.playbackStateDidChange,
      this.handlePlaybackStateDidChange
    );

    this.music.addEventListener(
      MusicKit.Events.authorizationStatusDidChange,
      this.handleAuthorizationStatusDidChange
    );

    this.music.addEventListener(
      MusicKit.Events.mediaItemDidChange,
      this.handleMediaItemDidChange
    );
  }

  getPlayerType() {
    if (this.props.playlist_id) {
      return "Playlist";
    } else if (this.props.album_id) {
      return "Album";
    } else {
      return "Song";
    }
  }

  getMediaId() {
    if (this.props.playlist_id) {
      return this.props.playlist_id;
    } else if (this.props.album_id) {
      return this.props.album_id;
    } else {
      return this.props.song_id;
    }
  }

  getMetaInfo() {
    if (!this.state.mediaItem) {
      return;
    }
    if (this.props.playlist_id) {
      return (
        this.state.mediaItem.attributes.name +
        " - " +
        this.state.mediaItem.attributes.curatorName
      );
    } else if (this.props.album_id) {
      return (
        this.state.mediaItem.attributes.name +
        " - " +
        this.state.mediaItem.attributes.artistName
      );
    } else {
      return (
        this.state.mediaItem.attributes.name +
        " - " +
        this.state.mediaItem.attributes.artistName
      );
    }
  }

  async setup() {
    let mediaItem;

    /* this.music.player.repeatMode = 0; */

    if (this.state.mediaType == "song") {
      mediaItem = await this.music.api.song(this.props.song_id);
      await this.music.setQueue({ song: mediaItem.id });
    } else if (this.state.mediaType == "playlist") {
      mediaItem = await this.music.api.playlist(this.props.playlist_id);
      await this.music.setQueue({ playlist: mediaItem.id });
    } else if (this.state.mediaType == "album") {
      mediaItem = await this.music.api.album(this.props.album_id);
      await this.music.setQueue({ album: mediaItem.id });
    }

    console.log("setup, check queue: ", this.music.player._queue);

    this.setState({ mediaItem: mediaItem, isPlaying: false, isLoading: false });

    this.sendGaEvent("didLoad");
    this.sendFbEvent("Apple_player_impressions");
  }

  sendGaEvent(action) {
    const ga = window.ga;

    ga("send", "event", {
      eventCategory: "Apple Music Player",
      eventAction: action,
      eventLabel: this.getPlayerType(),
      dimension15: this.getMetaInfo(),
    });
  }

  sendFbEvent(action) {
    // We load the facebook script since, its not available by default on AMP templates.
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );

    fbq("init", "1585976395046779");
    fbq("trackSingleCustom", "1585976395046779", action);

    console.log("sent fb event: ", action);
  }

  handlePlaybackTimeDidChange() {
    /* console.log("handlePlaybackTimeDidChange: ", this.state.playbackTime); */
    if (
      !this.state.isAuthorized &&
      this.state.playbackTime >= 15 &&
      !this.state.upsellClosed
    ) {
      if (this.props.version != "2") {
        this.setState({ showUpsell: true, isOverlay: true });
      }
    }

    this.setState({ playbackTime: this.state.playbackTime + 1 });
  }

  async handlePlaybackStateDidChange() {
    console.log(
      "handlePlaybackStateDidChange: ",
      MusicKit.PlaybackStates[this.music.player.playbackState]
    );

    if (this.music.player.playbackState == MusicKit.PlaybackStates.loading) {
      /* console.log("set loading"); */
      this.setState({ isLoading: true });
    } else if (
      this.music.player.playbackState == MusicKit.PlaybackStates.playing
    ) {
      /* console.log("set playing"); */

      this.setState({ isPlaying: true, isLoading: false });

      this.sendGaEvent("didPlay");
      this.sendFbEvent("Apple_player_play");
    } else if (
      this.music.player.playbackState == MusicKit.PlaybackStates.ended
    ) {
      /* console.log("set ended"); */
      if (this.state.mediaType == "song") {
        /* debugger; */
        /* await this.music.setQueue({ song: this.state.mediaItem.id }); */
        //this.sendGaEvent("didPlay");
        await this.music.player.pause();
        this.setState({ isPlaying: false, isLoading: false });
      }
    } else if (
      this.music.player.playbackState == MusicKit.PlaybackStates.paused
    ) {
      /* console.log("set pause"); */

      let isOverlay = false;
      let showUpsell = false;
      if (this.props.version != "2" && !this.state.isAuthorized) {
        isOverlay = true;
        showUpsell = true;
      }

      this.setState({
        isPlaying: false,
        isOverlay: isOverlay,
        showUpsell: showUpsell,
      });
      this.sendGaEvent("didPause");
    } else {
      /* console.log("catch all"); */
    }
  }

  async handleAuthorizationStatusDidChange() {
    /* console.log("handleAuthorizationStatusDidChange"); */
    if (this.music.isAuthorized) {
      /* console.log("didAuthorize"); */
      this.setState({
        isAuthorized: true,
        isOverlay: false,
        showUpsell: false,
      });

      await this.setup();

      this.sendGaEvent("didAuthorize");
      this.sendFbEvent("Apple_user");
    } else {
      /* console.log("didUnauthorize"); */
      this.setState({
        isAuthorized: false,
        isOverlay: false,
        showLogout: false,
      });

      await this.setup();
      this.sendGaEvent("didUnauthorize");
    }
  }

  handleMediaItemDidChange() {
    let nowPlayingItem = this.music.player.nowPlayingItem;
    /* console.log("handleMediaItemDidChange"); */

    this.setState({ nowPlayingItem: nowPlayingItem });
  }

  async play() {
    console.log("play");

    this.sendGaEvent("willPlay");
    await this.music.player.play();
    /* this.setState({
     *   isLoading: true
     * }); */

    /* console.log("done play"); */
  }

  async skip() {
    /* console.log("skip"); */

    this.sendGaEvent("willSkip");
    await this.music.player.skipToNextItem();
  }

  async pause() {
    /* console.log("pause"); */

    this.sendGaEvent("willPause");
    await this.music.player.pause();
  }

  async signIn() {
    /* console.log("signIn"); */

    this.sendGaEvent("willAuthorize");
    await this.music.authorize();
  }

  async signOut() {
    /* console.log("signOut"); */

    this.sendGaEvent("willUnauthorize");
    await this.music.unauthorize();
  }

  showLogoutModal() {
    /* console.log("showLogoutModal"); */

    this.setState({
      isOverlay: true,
      showLogout: true,
    });
  }

  closeUpsellModal() {
    /* console.log("closeUpsellModal"); */
    this.setState({ isOverlay: false, showUpsell: false, upsellClosed: true });
  }

  closeLogoutModal() {
    /* console.log("closeLogoutModal"); */
    this.setState({ isOverlay: false, showLogout: false });
  }

  tryItNow() {
    let tryItNowLink = "";
    if (this.props.version == "2") {
      if (this.state.mediaType == "song") {
        tryItNowLink =
          "https://music.apple.com/subscribe?app=music&mttnsiteid=125115&mttnagencyid=2433&mttncc=US&mttnpid=361319&itscg=20300&itsct=rv_eve&mttnsubad=20110006536&country_code=US&at=1010lsF4&ct=20110006536&HOLD";
      } else if (this.state.mediaType == "album") {
        tryItNowLink =
          "https://music.apple.com/subscribe?app=music&mttnsiteid=125115&mttnagencyid=2433&mttncc=US&mttnpid=361319&itscg=20300&itsct=rv_eve&mttnsubad=20110006537&country_code=US&at=1010lsF4&ct=20110006537&HOLD";
      } else {
        tryItNowLink =
          "https://music.apple.com/subscribe?app=music&mttnsiteid=125115&mttnagencyid=2433&mttncc=US&mttnpid=361319&itscg=20300&itsct=rv_eve&mttnsubad=20110006538&country_code=US&at=1010lsF4&ct=20110006538&HOLD";
      }
    } else {
      // tryItNowLink =
      //   "itmss://finance-app.itunes.apple.com/deeplink?itscg=50000&itsct=web_player&i=401126396&app=music&p=subscribe-individual&ign-refClientId=4zUG1POLFz152qt1zB6Dz4vVzCaFzUEphlXYW";

      tryItNowLink =
        "https://music.apple.com/subscribe?app=music&mttnsiteid=125115&mttnagencyid=2433&mttncc=US&mttnpid=361319&itscg=20300&itsct=rv_eve&mttnsubad=20110006174&country_code=US&at=1010lsF4&ct=20110006174";
    }

    this.sendGaEvent("willTry");
    this.sendFbEvent("Apple_player_free_trial");

    console.log("tryItNowLink: ", tryItNowLink);

    window.open(tryItNowLink, "_new");
  }

  render() {
    if (this.state.mediaItem == null) {
      let classNames = "apple-music-player ".concat(this.state.mediaType);
      return (
        <div className={classNames}>
          <div className="am__loading">
            <div className="am__loading__logo">
              <span className="logo" />
            </div>
          </div>
        </div>
      );
    }

    // console.log("mediaItem: ", this.state.mediaItem);

    var player = this.renderPlayer();

    // return <ErrorBoundary>{this.renderPlayer()}</ErrorBoundary>;
    return <div>{player}</div>;
  }

  renderSignIn() {
    if (this.state.isAuthorized) {
      return (
        <button
          className="am__header__auth authorized"
          onClick={this.showLogoutModal}
        >
          <span className="icon" />
        </button>
      );
    } else {
      return (
        <button className="am__header__auth unauthorized" onClick={this.signIn}>
          Sign In For Full Playback
        </button>
      );
    }
  }

  renderTrackList() {
    return (
      <TrackList
        music={this.music}
        mediaItem={this.state.mediaItem}
        mediaType={this.state.mediaType}
      />
    );
  }

  renderPlayer() {
    let artwork = "";
    let title = "";
    let underTitle = "";
    let artist = "";

    let classNames = "apple-music-player ".concat(this.state.mediaType);
    if (this.state.isOverlay) {
      classNames = classNames + " overlay";
    }

    if (this.props.version == "2") {
      classNames = classNames.concat(" version2");
    }

    if (this.state.isAuthorized) {
      classNames = classNames.concat(" authorized");
    } else {
      classNames = classNames.concat(" unauthorized");
    }

    let pop = "";
    if (this.props.version == "2") {
      pop = this.renderPop();
    }

    let trackList = "";
    if (this.state.mediaType == "playlist" || this.state.mediaType == "album") {
      trackList = this.renderTrackList();
    }

    if (this.state.mediaItem) {
      artwork = this.renderArtwork();
      title = this.state.mediaItem.attributes.name;

      if (this.state.mediaType == "song" || this.state.mediaType == "album") {
        underTitle = this.state.mediaItem.attributes.artistName;
      } else if (this.state.mediaType == "playlist") {
        underTitle = this.state.mediaItem.attributes.curatorName;
      }
    }

    if (this.state.nowPlayingItem) {
      if (this.state.mediaType == "song") {
        underTitle =
          this.state.nowPlayingItem.attributes.artistName +
          " — " +
          this.state.nowPlayingItem.title;
      } else if (this.state.mediaType == "playlist") {
        title = this.state.nowPlayingItem.attributes.name;
        underTitle =
          this.state.nowPlayingItem.attributes.artistName +
          " — " +
          this.state.mediaItem.attributes.curatorName;
      } else if (this.state.mediaType == "album") {
        title = this.state.nowPlayingItem.attributes.name;
        underTitle =
          this.state.nowPlayingItem.attributes.artistName +
          " — " +
          this.state.mediaItem.attributes.name;
      }
    }

    let description = this.state.mediaItem.attributes.description ? (
      <p className="description">
        {this.state.mediaItem.attributes.description.short}
      </p>
    ) : (
      ""
    );

    let editorial =
      this.state.mediaType == "playlist" || this.state.mediaType == "album" ? (
        <div>
          <div className="song__count">
            {this.state.mediaItem.relationships.tracks.data.length} Songs
          </div>
          {description}
        </div>
      ) : (
        ""
      );

    let badgeClassName = "";
    if (this.state.nowPlayingItem) {
      badgeClassName =
        this.state.nowPlayingItem.attributes.contentRating == "explicit"
          ? "badge explicit"
          : "badge";
    } else {
      badgeClassName =
        this.state.mediaItem.attributes.contentRating == "explicit"
          ? "badge explicit"
          : "badge";
    }

    return (
      <div className={classNames}>
        <div className="am__container">
          <div className="am__header">
            <button className="am__header__logo">
              <span className="logo" />
            </button>

            {this.renderSignIn()}
          </div>

          <div className="am__body">
            <div className="am__artwork">
              <div onClick={this.play} className="am__artwork__container">
                {artwork}
              </div>
              {editorial}
            </div>

            <div className="am__lcd">
              <div className="am__info">
                <div onClick={this.play} className="am__info__name">
                  <span className="name">{title}</span>
                  <span className={badgeClassName} />
                </div>

                <div className="am__info__sub">
                  <span>{underTitle}</span>
                </div>
              </div>

              <div className="am__controls">
                <div className="am__controls__container">
                  {this.renderControl()}
                  <PlayerTime
                    mediaItem={this.state.nowPlayingItem}
                    music={this.music}
                  />
                  <div className="am__scrub__time">
                    <span className="time">
                      {this.getCurrentPlaybackDuration()}
                    </span>
                  </div>
                  <button className="am__share" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {pop}

        {trackList}

        {this.renderUpsellModal()}

        {this.renderLogoutModal()}
      </div>
    );
  }

  renderPop() {
    return (
      <div className="am__pop">
        <div className="am__modal__ctas">
          <button className="cta" onClick={this.tryItNow}>
            Start Free Trial
          </button>
          <button className="login" onClick={this.signIn}>
            Sign In For Full Playback
          </button>
        </div>
        <div className="am__modal__copy">
          Play FADER approved playlists, songs, and albums. New members get 3
          months free. <span>Terms apply.</span>
        </div>
      </div>
    );
  }

  getCurrentPlaybackDuration() {
    return this.getTime(this.music.player.currentPlaybackTimeRemaining * 1000);
  }

  getTime(ms) {
    if (!ms || isNaN(ms)) {
      ms = 0;
    }

    const s = 1000 * Math.round(ms / 1000);
    const d = new Date(s);
    return `${d.getUTCMinutes()}:${String(`0${d.getUTCSeconds()}`).slice(-2)}`;
  }

  renderArtwork() {
    // throw "Test Airbrake Exception!";
    let size = 600;

    let artworkUrl = MusicKit.formatArtworkURL(
      this.state.mediaItem.attributes.artwork,
      size,
      size
    );

    return <img src={artworkUrl} />;
  }

  renderControl() {
    if (this.state.isLoading) {
      return (
        <div className="am__control">
          <div className="am__controls__spinner">
            <FontAwesomeIcon icon={faSpinner} />
          </div>
        </div>
      );
    }

    let skip =
      this.state.mediaType == "playlist" || this.state.mediaType == "album" ? (
        <button class="skip" onClick={this.skip.bind(this)}>
          <span class="icon" />
        </button>
      ) : (
        ""
      );

    let playOrPause = this.state.isPlaying ? (
      <button className="pause" onClick={this.pause.bind(this)}>
        <span className="icon" />
      </button>
    ) : (
      <button className="play" onClick={this.play}>
        <span className="icon" />
      </button>
    );

    return (
      <div className="am__control">
        {playOrPause}
        {skip}
      </div>
    );
  }

  renderUpsellModal() {
    let classNames = "am__modal am__modal--upsell";
    if (this.state.showUpsell) {
      classNames = classNames + " show";
    } else {
      classNames = classNames + " hide";
    }

    return (
      <div className={classNames}>
        <div className="am__modal__overlay" />
        <button className="am__modal__close" onClick={this.closeUpsellModal} />
        <div className="am__modal__bg">
          <div className="am__modal__content">
            <div className="am__modal__logo" />
            <div className="am__modal__copy">
              Play FADER approved playlists, songs, and albums. New members get
              3 months free. <span>Terms apply.</span>
            </div>
            <div className="am__modal__ctas">
              <button className="cta" onClick={this.tryItNow}>
                Start Free Trial
              </button>
              <button className="login" onClick={this.signIn}>
                Sign In For Full Playback
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLogoutModal() {
    let classNames = "am__modal am__modal--logout";
    if (this.state.showLogout) {
      classNames = classNames + " show";
    } else {
      classNames = classNames + " hide";
    }

    return (
      <div className={classNames}>
        <div className="am__modal__overlay" />
        <button className="am__modal__close" onClick={this.closeLogoutModal} />
        <div className="logout-modal__bg">
          <div className="logout-modal__content">
            <div className="logout-modal__icon" />
            <div className="logout-modal__container">
              <div className="logout-modal__message">
                You're signed in to Apple&nbsp;Music.{" "}
              </div>
              <button className="logout-modal__button" onClick={this.signOut}>
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default hot(AppleMusic);
